import { useState, useRef } from 'react';
import useAppSelector from '@sportson/core-web/hooks/useAppSelector';
import { shallowEqual } from 'react-redux';
import styled from 'libs/styled';

import CmsModules from '@sportson/core-web/libs/wordpress/content/CmsModules';
import Breadcrumbs from 'components/Breadcrumbs';
import Pagination from 'components/Pagination';
import { PostsContainerToAlgoliaArticle } from 'content/ArticlesPromotion/PostsContainerToAlgoliaArticle';

import { ArticleCollectionLayout } from './ArticleCollectionLayout';

const Wrapper = styled('div')``;

const ArticleCollection = () => {
    const wrapperRef = useRef();
    const pageData = useAppSelector(({ page }) => page?.data, shallowEqual);
    const breadcrumbData = [{ permalink: null, title: pageData?.title }];
    const heroContent = useAppSelector(({ page }) => page?.data?.heroContent, shallowEqual);
    const pageContent = useAppSelector(({ page }) => page?.data?.pageContent, shallowEqual);
    const [currentPage, setCurrentPage] = useState(0);
    const articlesPerPage = 9;

    const [filterCategory, setSelectedCategory] = useState('');

    const handleCatChange = (cat) => {
        setSelectedCategory(cat);
        setCurrentPage(0);
    };

    const scrollToTop = (next, smooth = false) => {
        setCurrentPage(next);

        if (wrapperRef && wrapperRef.current) {
            scrollTo({
                smooth,
                top: wrapperRef.current.offsetTop,
            });
        }
    };

    return (
        <>
            <Breadcrumbs
                gridColumn="standard"
                p={['16px 24px 16px 12px', null, null, null, null, '16px 40px']}
                breadcrumbs={breadcrumbData}
            />

            {/* TODO: NOTE: MAKE Article Hero (Featured Cards) required on collections page? */}
            {heroContent && <CmsModules isHero data={heroContent} />}

            {/* TODO: NOTE: Add ids to PostsContainerToAlgoliaArticle */}
            <PostsContainerToAlgoliaArticle filterCategory={filterCategory} currentPage={currentPage}>
                {({ data }) => (
                    <Wrapper ref={wrapperRef}>
                        <ArticleCollectionLayout {...data} title={pageData?.title} onCategoryChange={handleCatChange} />
                        <Pagination
                            handleClick={scrollToTop}
                            page={data?.data?.page}
                            pageCount={data?.data?.pageCount}
                            pageSize={articlesPerPage}
                        />
                    </Wrapper>
                )}
            </PostsContainerToAlgoliaArticle>

            {pageContent && <CmsModules data={pageContent} />}
        </>
    );
};

export default ArticleCollection;
